"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'OpenAPIComponent',
  props: {
    isShow: {
      require: true,
      type: Boolean
    },
    // eslint-disable-next-line vue/require-default-prop
    mediaId: {
      require: false,
      type: String
    },
    // eslint-disable-next-line vue/require-default-prop
    isLive: {
      require: false,
      type: String
    },
    // eslint-disable-next-line vue/require-default-prop
    path: {
      require: false,
      type: String
    }
  },
  methods: {
    openApp: function openApp() {
      var query = {};

      if (this.mediaId && this.isLive) {
        query.mediaId = this.mediaId;
        query.isLive = this.isLive;
      } else {
        query.path = this.path;
      }

      this.$router.push({
        name: 'OpenInBrowser',
        query: query
      });
    }
  }
};
exports.default = _default;